import { render, staticRenderFns } from "./StagingDeliveryPage.vue?vue&type=template&id=59dd55c8&scoped=true&"
import script from "./StagingDeliveryPage.vue?vue&type=script&lang=js&"
export * from "./StagingDeliveryPage.vue?vue&type=script&lang=js&"
import style0 from "./StagingDeliveryPage.vue?vue&type=style&index=0&id=59dd55c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd55c8",
  null
  
)

export default component.exports